import { connect } from 'react-redux'
import { compose } from 'redux'
import { push } from 'connected-react-router'
import hasUpdateProgram from '../../hoc/hasUpdateProgram'
import toJS from '../../hoc/toJS'
import getData from '../../functions/getData'
import { PROGRAM_CLI_MOVIES_ITEMS, PROGRAM_MOVIEMAPPING_ITEMS, PROGRAM_CINEMAS, PROGRAM_TMDB_MOVIES_ITEMS, CLI_CINEMA_CLIENT_ID } from '../../constants/state'
import PageTmdbPage from '../../components/PageTmdb/present/PageTmdbPage'

const mapStateToProps = (state) => ({
    movies: getData(state, PROGRAM_CLI_MOVIES_ITEMS),
    movieMappings: getData(state, PROGRAM_MOVIEMAPPING_ITEMS),
    tmdbMovies: getData(state, PROGRAM_TMDB_MOVIES_ITEMS),
    cinemas: getData(state, PROGRAM_CINEMAS),
    clientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID),
})

const mapDispatchToProps = (dispatch) => ({
    onNavigate: (path) => dispatch(push(path))
})

export default compose(
    hasUpdateProgram(),
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(PageTmdbPage)
